import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import type { MatChipListboxChange } from '@angular/material/chips';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslatePipe } from '@ngx-translate/core';

type Lang = 'nl' | 'en' | 'de' | 'it' | 'fr';

@Component({
  selector: 'app-localized-text-editor',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, MatChipsModule, MatFormFieldModule, MatInputModule, TranslatePipe],
  templateUrl: './localized-text-editor.component.html',
})
export class LocalizedTextEditorComponent {
  readonly nl = input.required<FormControl<string | null>>();
  readonly en = input.required<FormControl<string | null>>();
  readonly de = input.required<FormControl<string | null>>();
  readonly it = input.required<FormControl<string | null>>();
  readonly fr = input.required<FormControl<string | null>>();

  readonly langs: Lang[] = ['nl', 'en', 'de', 'it', 'fr'];
  readonly activeLang = signal<Lang>('nl');

  readonly activeControl = computed<FormControl<string | null>>(() => this.controlFor(this.activeLang()));

  controlFor(lang: Lang): FormControl<string | null> {
    const map: Record<Lang, FormControl<string | null>> = {
      nl: this.nl(),
      en: this.en(),
      de: this.de(),
      it: this.it(),
      fr: this.fr(),
    };
    return map[lang];
  }

  onLangChange(event: MatChipListboxChange): void {
    if (event.value != null) this.activeLang.set(event.value as Lang);
  }
}
